export class RfqSessionNudgeSettingTriggerTimingAmountType {
	public id: number;
	public name: string;

	constructor(rfqSessionNudgeSettingTriggerTimingAmountType?: RfqSessionNudgeSettingTriggerTimingAmountType) {
		Object.assign(this, rfqSessionNudgeSettingTriggerTimingAmountType);
	}
}
